import React, { useState } from 'react'
import { MetricsProvider } from './context'
import { MetricsDashboardPropTypes } from './PropTypes'
import { ScenarioHeader as Header } from '@components/ScenarioHeader'
import { GroupProjection } from './components/GroupProjection'
import { TotalAssetsCards } from './components/TotalAssetsCards'
import { BudgetCards } from './components/BudgetCards'
import { SafeRetirementStatus } from './components/SafeRetirementStatus'
import { RiskProfile } from './components/RiskProfile'
import { Grid } from '@components/layout/Grid'

export const MetricsDashboard = (props) => {
  const [usePresentValue, setUsePresentValue] = useState(true)
  const { groupName } = props
  return (
    <MetricsProvider {...props}>
      <Grid metrics className='metrics-dashboard'>
        <Header
          label={'Group name'}
          scenarioName={`${groupName} Metrics`}
          usePresentValue={usePresentValue}
          setUsePresentValue={(usePresentValue) => setUsePresentValue(usePresentValue)}
        >
          <Header.PlanName />
          <Header.TimeValueToggle />
        </Header>
        <section className='projections'>
          <GroupProjection usePresentValue={usePresentValue} />
        </section>
        <aside className='aside'>
          <TotalAssetsCards usePresentValue={usePresentValue} />
          <BudgetCards />
        </aside>
        <SafeRetirementStatus />
        <RiskProfile />
      </Grid>
    </MetricsProvider>
  )
}

MetricsDashboard.propTypes = MetricsDashboardPropTypes
